module.exports = __webpack_public_path__ + "img/improve-supply-chain.eb7c9a58.webp";